import axios from 'axios';

// GK 2023-10-22 - look for "api/user", then look for the associated user.js, then find the "me" endpoint
export const getUser = () => {
    return axios.get('/api/user/me');
};